export default {
  methods: {
    alertIfIE () {
      const userAgent = window.navigator.userAgent.toUpperCase()
      if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('TRIDENT') !== -1) {
        alert('ご使用のブラウザではメディアポータルをご利用になれません。\n他のブラウザ（Microsoft Edge, Google Chromeなど）をお使いください。')
      }
    }
  }
}
